import { annualBenefitPlanningApi } from '../../../shared/infra/api/annual-benefit-planning.api'

import type {
  EnrollmentPeriodDto,
  ListEnrollmentPeriodsDto,
} from './enrollment-periods.dto'

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

function isEnrollmentPeriodDto(value: unknown): value is EnrollmentPeriodDto {
  return (
    isRecord(value) &&
    typeof value.oepId === 'string' &&
    typeof value.benefitEffectiveDate === 'string' &&
    typeof value.enrollmentStartDate === 'string' &&
    typeof value.enrollmentEndDate === 'string' &&
    typeof value.isEnded === 'boolean' &&
    typeof value.isPaused === 'boolean' &&
    typeof value.isDefault === 'boolean'
  )
}

function parseEnrollmentPeriodsPayload(
  response: unknown
): ListEnrollmentPeriodsDto | null {
  if (!isRecord(response) || response.status !== 'ok') {
    return null
  }
  const payload = response.data
  if (!isRecord(payload) || !Array.isArray(payload.items)) {
    return null
  }
  const items = payload.items.filter(isEnrollmentPeriodDto)
  if (items.length !== payload.items.length) {
    // Keep the valid periods usable, but make a backend contract regression visible
    // instead of silently shrinking the drop-down.
    console.warn(
      `listEnrollmentPeriods: dropped ${payload.items.length - items.length} malformed enrollment period(s) from the response`
    )
  }
  return { items }
}

export async function listEnrollmentPeriods(
  customerId: string
): Promise<ListEnrollmentPeriodsDto> {
  const { data } = await annualBenefitPlanningApi.get<unknown>(
    `clients/${encodeURIComponent(customerId)}/policy/enrollment-periods`
  )
  const parsed = parseEnrollmentPeriodsPayload(data)
  if (parsed === null) {
    throw new Error('Invalid enrollment periods response')
  }
  return parsed
}
